import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import medium from '~img/logos/social/medium.svg'
import twitter from '~img/logos/social/twitter.svg'
import telegram from '~img/logos/social/telegram.svg'

import * as s from './FooterTop.module.scss'

const FOOTER_NAV_QUERY = graphql`
  query FooterNav {
    navigationJson {
      navigationData {
        title
        links {
          title
          to
          target
          rel
        }
      }
      socialData {
        links {
          title
          to
        }
        title
      }
    }
  }
`

const FooterTop = () => {
  const data = useStaticQuery(FOOTER_NAV_QUERY)
  const { navigationData, socialData } = data.navigationJson || {
    navigationData: [],
    socialData: [],
  }

  const socialImages = {
    0: twitter,
    1: telegram,
    2: medium,
  }

  const social = socialData?.map((item) => ({
    ...item,
    links: item?.links?.map((link, index) => ({
      ...link,
      img: socialImages[index],
    })),
  }))

  return (
    <nav className={s.footerTop}>
      {navigationData?.map((navItem) => (
        <div key={navItem.title}>
          <p className={s.columnTitle}>{navItem.title}</p>
          <ul>
            {navItem.links.map((link) => (
              <li key={link.title} className={s.link}>
                <a href={link.to} target={link.target} rel={link.rel}>
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className={s.community}>
        {social?.map((navItem) => (
          <div key={navItem.title}>
            <p className={s.columnTitle}>{navItem.title}</p>
            <ul>
              {navItem.links.map((link) => (
                <li key={link.title} className={s.link}>
                  <a
                    href={link.to}
                    className="flex items-center justify-center md:justify-start"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={link.img}
                      alt={link.title}
                      className="w-4 h-auto"
                    />
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </nav>
  )
}

export default FooterTop
